import * as Yup from "yup";
import i18n from '../../i18n/i18n';

export const changePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string().required(() => i18n.t('validation.oldPasswordIsRequired')),
  newPassword: Yup
    .string()
    .required(() => i18n.t('validation.passwordIsRequired'))
    .min(6, () => i18n.t('validation.passwordMustBeAtLeast6'))
    .max(50, () => i18n.t('validation.passwordMustBeAtMost50'))
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?#&^()_+=-]).*$/,
      () => i18n.t('validation.useUppercaseLowercaseNumberSymbol')
    ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword")], () => i18n.t('validation.passwordsMustMatch'))
    .required(() => i18n.t('validation.confirmPasswordIsRequired')),
});
